module.exports = __webpack_public_path__ + "img/lookbook_8_center.f56fc3ed.png";